// Base Client
import { RpcError } from "grpc-web";
import { getApiToken } from "../helpers";
import { getBffRequest } from "./base/api";

// Protos
import { ClaimsBFFControllerClient } from "./protos/Claims-bffServiceClientPb";
import { PaymentsGetBillsForCaseRequest, PaymentsGetBillsForCaseResponse } from "./protos/messages/payments.message_pb";

export const getBillsForCase = async (caseId: number): Promise<PaymentsGetBillsForCaseResponse> => {
	const token: string = getApiToken();

	const request = new PaymentsGetBillsForCaseRequest();
	request.setId(caseId);

	const client: ClaimsBFFControllerClient = getBffRequest(token);
	return client
		.getBillsForCase(request, {})
		.then((response: PaymentsGetBillsForCaseResponse) => response)
		.catch((err: RpcError) => {
			console.error(err);
			throw err;
		});
};
